import React from "react";
import * as CHQ from "chq";

import { Trans } from "app/utils";
import { ProfileLink } from "app/links";
import { useProfile } from "app/context";
import NotificationBody from "./NotificationBody";

type ProcessingNeededApprovalVideoStoryNotificationProps = {
  notification: CHQ.NotificationProcessingNeededApprovalVideoStory;
};

const isImage = (
  notification: CHQ.NotificationProcessingNeededApprovalVideoStory
) => notification.notificationType === "processing_needed_approval_image_story";

const ProcessingNeededApprovalVideoStoryNotification: React.FC<
  ProcessingNeededApprovalVideoStoryNotificationProps
> = ({ notification }) => {
  const { profile } = useProfile();
  const user = notification.entity || profile;
  return (
    <NotificationBody actor={user}>
      <>
        {isImage(notification) ? (
          <Trans>
            Your story has been sent for review to be approved by an admin.
            For now, you can view it on your{" "}
            <ProfileLink user={user}>
              <Trans>profile.</Trans>
            </ProfileLink>
          </Trans>
        ) : (
          <Trans>
            Your video story is being processed. We will let you know as soon
            as it is ready.
          </Trans>
        )}
        <br />
      </>
    </NotificationBody>
  );
};

export default ProcessingNeededApprovalVideoStoryNotification;
